/**
 * @file components/log/weightCharts/CalorieComplianceChart.jsx
 * @description Daily calories eaten vs the daily budget.
 */

import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  CHART_MARGIN,
  GRID_PROPS,
  X_AXIS_PROPS,
  Y_AXIS_PROPS,
} from "./chartUtils";
import { CustomTooltip } from "./chartUI";

export function CalorieComplianceChart({ data }) {
  return (
    <ResponsiveContainer width="100%" height={280} debounce={200}>
      <ComposedChart data={data} margin={CHART_MARGIN}>
        <CartesianGrid {...GRID_PROPS} />
        <XAxis dataKey="dateDisplay" {...X_AXIS_PROPS} />
        <YAxis {...Y_AXIS_PROPS} />
        <Tooltip content={<CustomTooltip unit="kcal" />} />
        <Bar
          dataKey="calories"
          fill="#10b981"
          radius={[4, 4, 0, 0]}
          barSize={20}
          name="Eaten"
        />
        <Line
          type="stepAfter"
          dataKey="target"
          stroke="#f59e0b"
          dot={false}
          strokeWidth={2}
          name="Daily Budget"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
